import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactTags from 'react-tag-autocomplete';

import RaisedButton from 'material-ui/RaisedButton';
import { TableRow, TableRowColumn } from 'material-ui/Table';

import api from 'services';
import styles from 'styles';
import { savePort, updatePortSuggestions, updatePortAlt } from 'actions/regions/ports';

const PortsAltNamesRow = ({
    item: initialItem,
    tags: initialTags,
    suggestionsPorts,
    savePort,
    updatePortSuggestions,
    updatePortAlt,
    updateExternalAltsState,
}) => {
    const [item, setItem] = useState(initialItem);
    const [tags, setTags] = useState(initialTags);

    useEffect(() => {
        setItem(initialItem);
        setTags(initialTags);
    }, []);

    const updatePort = useCallback(() => {
        updatePortAlt(item);
        updatePortSuggestions([]);
        const newItem = {
            ...item,
            isUpdate: false,
            alt: tags.map(tag => tag.name),
        };

        setItem(newItem);
        updateExternalAltsState && updateExternalAltsState(newItem.alt);
    }, [item, updatePortAlt]);

    const handleInputChange = (searchText) => {
        if (searchText.length < 3) {
            updatePortSuggestions([]);
            return;
        }

        api.findPortAdmin({ name: searchText, withAreas: true })
            .then((response) => {
                updatePortSuggestions(response.data.data);
            });
    };

    const handleDelete = useCallback((i) => {
        const newTags = tags.slice(0);
        newTags.splice(i, 1);

        const newItem = {
            ...item,
            isUpdate: true,
            alt: newTags.map(newTag => newTag.name),
        };

        setTags(newTags);
        setItem(newItem);

        updatePortSuggestions([]);
        savePort(newItem);
    }, [tags, item, savePort, updatePortSuggestions]);

    const handleAddition = useCallback((tag) => {
        if (!tag.name.replace(/\s/g, '').length) {
            return;
        }

        const alreadySuggested = suggestionsPorts.some(port => port.name.toLowerCase() === tag.name.toLowerCase());

        if (alreadySuggested) {
            return;
        }

        const newTags = [...tags, tag];

        const newItem = {
            ...item,
            isUpdate: true,
            alt: newTags.map(newTag => newTag.name),
        };

        setTags(newTags);
        setItem(newItem);

        updatePortSuggestions([]);
        savePort(newItem);
    }, [tags, item, suggestionsPorts, savePort, updatePortSuggestions]);

    return (
        <TableRow>
            <TableRowColumn style={styles.tableRowColumnCSS}>
                {`${item.name} (${item.country ? item.country.name : ''})`}
            </TableRowColumn>

            <TableRowColumn style={styles.tableRowColumnCSS}>
                <ReactTags
                    allowNew
                    autofocus={false}
                    tags={tags}
                    suggestions={[]}
                    handleDelete={handleDelete}
                    handleAddition={handleAddition}
                    handleInputChange={handleInputChange}
                />
            </TableRowColumn>

            <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                <div className={item.isUpdate ? 'update-item' : 'hidden update-item'}>
                    <RaisedButton label='Update' primary onClick={updatePort} />
                </div>
            </TableRowColumn>
        </TableRow>
    );
};

export default connect(
    ({ ports }, { item }) => {
        const tags = item.alt.map((port, key) => ({
            id: key,
            name: port,
        }));

        return {
            item,
            tags,
            suggestionsPorts: ports.suggestions,
        };
    },

    dispatch => bindActionCreators(
        {
            savePort,
            updatePortSuggestions,
            updatePortAlt,
        },
        dispatch,
    ),
)(PortsAltNamesRow);



// WEBPACK FOOTER //
// ./app/components/Regions/PortsAltNames/Row.jsx